import {ImmunizationMMRViewNew} from "./ImmunizationMMRViewNew";

export default ImmunizationMMRViewNew;
